// extracted by mini-css-extract-plugin
export default {"billing__selector__head":"BillingHead_billing__selector__head__XoXn+"};